<template>
	<v-container fluid align-start ma-0 pa-2 class="container-height">
		<v-row no-gutters fill-height>
			<v-col cols="12">
				<i-card-vertical :headerTitle="menuTitle" 
					:useBtnList="useBtnList"
					@btnRetrieve="btnRetrieve()" @btnPrint="btnPrint()" @btnRequestInsp="btnRequestInsp()"
				>
					<template v-slot:body>
						<v-row>
							<v-col cols="12" class="pa-0">
								<i-card-top
									class="d-md-flex"
									outlined
								>
									<template v-slot:body>
										<v-row no-gutters class="center pa-0 pl-1">
											<v-col cols="12">
												<v-row dense>
													<i-label :label="'Supplier name : '" />
													<v-col cols="4">
														<v-select
															v-model="supName"
															:items="supNameList"
															item-value="supName"
															return-object
															single-line
															outlined
															dense
															@change="supNameChange"
														></v-select>
													</v-col>

												</v-row>
												<v-row dense class="ma-0">
													<i-label :label="'Ship No : '"/>
													<v-col cols="1">
														<v-select
															v-model="shipNo"
															:items="shipNoList"
															item-value="shipNo"
															return-object
															single-line
															outlined
															dense
														></v-select>
													</v-col>
													<i-label :label="'Period : '" class="pl-2"/>
													<v-col cols="1">
                            <DxDateBox
                              :value="stDate"
                              height="30px"
                              display-format="yyyy-MM-dd"
                              :acceptCustomValue="false"
                              @value-changed="e => {stDate = e.value && getStrFormat(e.value)}"
                            />
													</v-col>
                          <span class="pa-2"> ~ </span>
													<v-col cols="1" class="pl-0">
                            <DxDateBox
                              :value="edDate"
                              height="30px"
                              display-format="yyyy-MM-dd"
                              :acceptCustomValue="false"
                              @value-changed="e => {edDate = e.value && getStrFormat(e.value)}"
                            />
													</v-col>
													<i-label :label="'Inspection Kind : '" class="pl-2"/>
													<v-col cols="2" >
                            <v-select
                                v-model="inspKind"
                                :items="kindCdList"
                                item-value="inspKind"
                                return-object
                                single-line
                                outlined
                                dense
                                @change="btnRetrieve"
                            ></v-select>
													</v-col>  
												</v-row>
											</v-col>
										</v-row>
									</template>
								</i-card-top>
							</v-col>
						</v-row>

						<v-row no-gutters>
							<v-col cols="12" class="pt-1">
								<DxDataGrid id="requestList" 
									:ref="v80a1060Ref"
									class="hipGridHeight8_3"
									:data-source="gridMainList" 
									:remote-operations="false" 
									:hover-state-enabled="true"
									:allow-column-resizing="true" 
									:allow-column-reordering="true"
									:row-alternation-enabled="true" 
									:show-borders="true" 
									:width="grid.width"
									:show-row-lines="true" 
									key-expr="id" 
									:focused-row-enabled="true"
									:column-hiding-enabled="false" 
									:sorting="{ mode: 'none' }"
                  :selection="{ mode: 'none' }"
									:word-wrap-enabled="true"
									@cellPrepared="cellPrepared"
								> 

                  <DxColumn data-field="no" caption="No" width="3%" data-type="number" format="#,###" alignment="center" :allow-editing="false"/>
                  <DxColumn data-field="insRes" width="7%" data-type="string" header-cell-template="result" alignment="center" :allow-editing="false"/>
                  <template #result >
                    <div>
                      <span>Inspection<br>Result</span>
                    </div>
                  </template>
                  <DxColumn data-field="shipNo" caption="Ship No" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                  <DxColumn data-field="respNmeng" caption="Work Group" width="19%" data-type="string" alignment="center" :allow-editing="false"/>
                  <DxColumn data-field="block" caption="Block" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                  <DxColumn data-field="porNo" caption="POR No" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                  <DxColumn data-field="itemDesc" caption="Inspection Item" width="40%" data-type="string" alignment="center" :allow-editing="false"/>
                  <DxColumn caption="Inspection" data-type="string" alignment="center" :allow-editing="false" >
                    <DxColumn data-field="insDate" caption="Date" width="10%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="insTime" caption="Time" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                  </DxColumn>

									<DxPaging :enabled="true" :page-size="13" />
                  <DxPager :visible="true" :showInfo="false" />
								</DxDataGrid>
							</v-col>
						</v-row>
						<v-row no-gutters>
							<v-col cols="12">
								<v-row no-gutters>
									<v-col cols="12" class="subText">Count Total: {{ listSize }} Row(s)</v-col>
								</v-row>
								<v-row no-gutters>
									<v-col cols="3" class="subText">AA : Accept</v-col>
									<v-col cols="4" class="subText">PA : Cancel due to Bad weather</v-col>
									<v-col cols="3" class="subText">RA : Reject due to bad work</v-col>
								</v-row>
								<v-row no-gutters>
									<v-col cols="3" class="subText">AC : Confirm by QM</v-col>
									<v-col cols="4" class="subText">CA : Canceled by pro dep't</v-col>
									<v-col cols="3" class="subText">RB : Safety problem</v-col>
								</v-row>
								<v-row no-gutters>
									<v-col cols="3" class="subText">AD : Confirmed by OW/CL (Pro dept)</v-col>
									<v-col cols="4" class="subText">CB : Canceled by after confirmed by QM</v-col>
									<v-col cols="3" class="subText">RC : Not finished work</v-col>
								</v-row>
								<v-row no-gutters>
									<v-col cols="3" class="subText">AE : Confirmed by OW/CL (Others dept)</v-col>
									<v-col cols="4" class="subText">PD : Canceled due to OW/CL inspection at another location</v-col>
									<v-col cols="3" class="subText">RD : Process is interrupted</v-col>
								</v-row>
								<v-row no-gutters>
									<v-col cols="3" class="subText">LQ : Confirmed by Maker</v-col>
									<v-col cols="4" class="subText">PE : Canceled due to another process is interrupted</v-col>
									<v-col cols="3" class="subText">RE : Not yet cleaning</v-col>
								</v-row>
								<v-row no-gutters>
									<v-col cols="3" class="subText">PM : Cancelled during meeting with Owner</v-col>
									<v-col cols="4" class="subText">PF : Canceled due to OW/CL not understand</v-col>
									<v-col cols="3" class="subText">RF : Another</v-col>
								</v-row>
							</v-col>
						</v-row>

					</template>
				</i-card-vertical>
			</v-col>
		</v-row>
	</v-container>
</template>
	
<script>
	import { DxDataGrid, DxEditing, DxColumn , DxLookup, DxSelection, DxPager } from 'devextreme-vue/data-grid'
	import DxDateBox from 'devextreme-vue/date-box'
	import ICardVertical from '@/components/common/iCardVertical.vue'
	import iCardTop from '@/components/common/iCardTop.vue'
	import baseview from '@/components/base/baseview.vue' // base page 추가
	import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
	import { getSupplier , getV80ShipNo , getRespMaker } from '@/api/view/hip/8/v80a1040.js'
	import { v80a1060List } from '@/api/view/hip/8/v80a1060.js'
	import { reportView} from '@/api/view/hip/common/common.js'
	import { getCmChildCode } from '@/api/system/cmCodeManage'
  	import { getDateFormat , getCurrentDate } from '@/utils/common.js'
  	import dayjs from 'dayjs';
	
	export default {
		name: 'v80a1060',
		mixins: [baseview, BaseDataGrid],
		components: {
			ICardVertical,
			"i-card-top": iCardTop,
			DxDataGrid,
			DxColumn,
			DxEditing,
			DxDateBox,
			DxLookup,
			DxSelection,
			DxPager
		},
		data() {
			return {
				menuTitle: this.$route.meta.title,
				useBtnList: ['btnRetrieve', 'btnPrint' , 'btnRequestInsp'],
				v80a1060Ref: 'v80a1060Ref',
				gridMainList: [],

				stDate: null,
				edDate: null,
	
				supName: '',
				supNameList: [],

				shipNo: '',
				shipNoList: [],

				//kindCd: null,
       			inspKind : '',
				kindCdList: [],

				custCd: '',
				respCd: '',

				listSize: 0,

			}
		},
		computed: {
			gridMainInstance() {
				return this.GetDataGrid(this.v80a1060Ref)
			},
		},
		mounted() {
			this.init()
			this.gridMainInstance.option('defaultPaging', false)
		},
		methods: {
			getStrFormat(date) {
				return getDateFormat(date)
			},
			init(){
				let toDay = new Date
				this.stDate = toDay.setDate(toDay.getDate() - 5 );
       			toDay = new Date
				this.edDate = toDay.setDate(toDay.getDate() + 1 );
        
				this.stDate = dayjs(this.stDate).format('YYYY-MM-DD')
				this.edDate = dayjs(this.edDate).format('YYYY-MM-DD')

				this.getList()
				
				if (this.$store.state.user.userGrd !== 'A'){
					this.supNameChange()
				}
				
			},
			async getList(){
				try {
					this.openLoading('searching')
					let params = {
						// makerCd: this.$store.state.user.userGrd !== 'A' ? this.custCd : '%',
						makerCd: this.$store.state.user.userGrd !== 'A' ? this.$store.state.user.makerCd : '%',
						porDiv: 'Y',
						code: '',
						codegr: '',
						prtCode: 'INSP_DIV',
						userFlag: 'Y',
						shipGu: '2'
					}
					let params2 = {
						code: '',
						codegr: '',
						prtCode: 'KIND_CD',
						userFlag: 'Y',
					}

					await getSupplier(params).then(res => {
						// this.supNameList.push('Select Supplier')
						if (this.$store.state.user.userGrd == 'A') {
							this.supNameList.push('Select Supplier')
						}  
						res.list.forEach(e => {
							this.supNameList.push(e.custCd + ' : ' + e.custNm)
						});
						this.supName = this.supNameList[0]
					})

					getV80ShipNo(params).then(res => {
						this.shipNoList.push('All')
						res.list.forEach(e => {
							this.shipNoList.push(e.shipNo)
						});
						this.shipNo = this.shipNoList[0]
					})

					getCmChildCode(params2).then(res => {
						this.kindCdList.push('Select...')
						res.list.forEach(e => {
						this.kindCdList.push(e.codeName)
						});
						this.inspKind = this.kindCdList[0]

					})

					// console.log('yes!!!', this.custCd)
          /*	
					getCmChildCode(params2).then(res => {
						this.kindCdList.push({code: '' , codeName: 'Select...'})
						res.list.forEach(e => {
							this.kindCdList.push(e)
						});
            			this.kindCd = this.kindCdList[0].code
					})*/
				} finally {
					this.endLoading()
				}
			},
			async getMainList(){
				try {
					this.openLoading('searching')
					let kindCd = ''
					switch(this.inspKind){
						case 'Select...' : kindCd = ''
						break
						case 'Final Inspection' : kindCd = 'FIN'
						break
						case 'Filler Air Test' : kindCd = 'AIT'
						break
						case 'QM Inspection' : kindCd = 'INS'
						break
						case 'Dimension check' : kindCd = 'DIM'
						break
					}

					let params = {
							stDate: this.stDate,
							edDate: this.edDate,
							shipNo: this.shipNo === 'All' ? '' : this.shipNo ,
							kindCd: kindCd,
							custCd: this.custCd,
							makerCd: this.custCd
						}
						
					await v80a1060List(params).then(res => {

						res.list.forEach(e => {
						e.id = e.no 
						e.porNo =  (e.porNo === null ? '' : e.porNo ) + '-' + (e.porSeq === null ? '' : e.porSeq)
						});
						this.gridMainList = res.list
						this.listSize = res.list.length
					})
					await getRespMaker(params).then(res => {
						this.respCd = res.list[0].respCd
					})
	
				} finally {
				this.endLoading()
				}
			},
			supNameChange(){
				let supNameGbn = this.supName
				supNameGbn = supNameGbn.split(' : ')

				if (this.$store.state.user.userGrd !== 'A') {
					this.custCd = this.$store.state.user.makerCd 
				}
				else{
					this.custCd = supNameGbn[0]
				}

				// this.custCd = supNameGbn[0]

				// this.btnRetrieve()		
			},
			btnRetrieve(){
				if(!this.custCd){
					this.vToastify(this.$t('Please, Select Supplier to Retrieve!'), 'warn')
					return
				}
				this.getMainList()
			},
			btnPrint(){
				let kindCd = ''
				switch(this.inspKind){
				case 'Select...' : kindCd = ''
					break
				case 'Final Inspection' : kindCd = 'FIN'
					break
				case 'Filler Air Test' : kindCd = 'AIT'
					break
				case 'QM Inspection' : kindCd = 'INS'
					break
				case 'Dimension check' : kindCd = 'DIM'
					break
				}

				if(!this.custCd){
				this.vToastify(this.$t('Please, Select Supplier to Retrieve!'), 'warn')
				return
				}
				const param = {
					fileName: 'v80a1060_new.jrxml',
					as_st_date: this.stDate,
					as_fi_date: this.edDate,
					as_kind_cd: kindCd,
					as_resp_cd: this.respCd,
					as_ship_no: this.shipNo === 'All' ? '' :this.shipNo ,
				}
				this.openLoading('searching')
				reportView(param)
				.finally(() => {
					this.endLoading()
				})
			},
			btnRequestInsp(){
				this.$router.push({name: 'v80a1040' });
			},
			//cell merge ,color
			cellPrepared(e){
				if(e.rowType === 'data'){
					if(e.column.dataField === 'insRes' && e.row.data.insRes){
						e.cellElement.style.backgroundColor = '#FFFF00'
					}
				}
			},
		}
	}
</script>
<style lang="scss" scoped>
.subText{
	font-weight: bold;
	color: black;
}

$redBtn: #FF0000;
.setBtnColor::v-deep {
  [role=btnDelete]{
    .v-btn__content {
      div {
        color: #{$redBtn} !important;
      }

      i {
        color: #{$redBtn} !important;
      }
    }
  }
}
</style>